import { create } from 'zustand';

export type Theme = 'dark' | 'light' | 'darkBlue' | 'pink';

interface ThemeState {
  theme: Theme;
  setTheme: (theme: Theme) => void;
  initialize: () => void;
}

const THEME_STORAGE_KEY = 'starryScoutTheme';

export const useThemeStore = create<ThemeState>((set) => ({
  theme: 'dark',
  setTheme: (theme) => {
    set({ theme });
    try {
      localStorage.setItem(THEME_STORAGE_KEY, theme);
    } catch {
      // ignore storage failures
    }
  },
  initialize: () => {
    try {
      const stored = localStorage.getItem(THEME_STORAGE_KEY) as Theme | null;
      if (stored) {
        set({ theme: stored });
      }
    } catch {
      // ignore storage failures
    }
  },
}));

